import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductionLinesView } from "src/components/views/erp/production/masterData/productionLines/ProductionLinesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/productionLines")({
	staticData: { title: i18n.t("production_lines"), legacyViewKey: "productionLinesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductionLinesView />;
}
